import React from 'react';
import "./Summary.scss";
//MODELS
import Title from '@shared/library/dist/components/gest/Title/Title';
import { ISummary, ISummaryCard } from '../../models/components/components';
//COMPONENTS
import { GestCard } from '@shared/library';
import { TSection } from '../../AdministrationPanel';

const Summary = (props: {
    cardsConfig: ISummaryCard[];
    currSection?: ISummary<TSection>;
    setCurrSection: React.Dispatch<React.SetStateAction<ISummary<TSection> | undefined>>;
}) => {

    return <nav id='summary'>
        {props.cardsConfig.map((c, i) =>
            <GestCard
                {...c}
                key={`card-${c.title}`}
                id={c.title as string}
                title={c.title}
                style={{ width: `calc(100% * ${c.sections.length || 1})` }}
            >
                <div className='group'>
                    {c.sections.map((s, j) =>
                        <div
                            key={`summary-section-${s.stats.title}`}
                            className='section'
                        >
                            <div className='icon'>{s.stats.icon}</div>

                            <div className='stats'>
                                <span>{s.stats.title}</span>
                                <Title>{s.stats.value}{s.stats.max !== undefined ? `/${s.stats.max}` : ""}</Title>
                            </div>
                        </div>
                    )}
                </div>
            </GestCard>
        )}
    </nav>;
};
export default React.memo(Summary);